import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { styled }, "@mui/material/Card": Card, "@mui/material/CardHeader": CardHeader, "@mui/material/CardMedia": CardMedia, "@mui/material/CardContent": CardContent, "@mui/material/CardActions": CardActions, "@mui/material/Collapse": Collapse, "@mui/material/Avatar": Avatar, "@mui/material/IconButton": IconButton, "@mui/material/Typography": Typography, "@mui/material/colors": { red }, "@mui/icons-material/Favorite": FavoriteIcon, "@mui/icons-material/Share": ShareIcon, "@mui/icons-material/ExpandMore": ExpandMoreIcon, "@mui/icons-material/MoreVert": MoreVertIcon } } });
export default ClientProvider;
